import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  DynamicFormArrayComponent,
  DynamicFormArrayModel,
  DynamicFormControlCustomEvent,
  DynamicFormControlLayout,
  DynamicFormLayout,
  DynamicFormLayoutService,
  DynamicFormValidationService,
  DynamicTemplateDirective,
} from '@ng-dynamic-forms/core';
import { DynamicMaterialFormControlContainerComponent } from '../dynamic-material-form-control-container.component';

@Component({
  selector: 'dynamic-material-form-array',
  templateUrl: './dynamic-material-form-array.component.html',
  imports: [ReactiveFormsModule, NgClass, NgTemplateOutlet, DynamicMaterialFormControlContainerComponent],
})
export class DynamicMaterialFormArrayComponent extends DynamicFormArrayComponent {
  @Input() formLayout: DynamicFormLayout;
  @Input() group: FormGroup;
  @Input() layout: DynamicFormControlLayout;
  @Input() model: DynamicFormArrayModel;
  @Input() templates: QueryList<DynamicTemplateDirective> | undefined;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();

  @ViewChildren(forwardRef(() => DynamicMaterialFormControlContainerComponent))
  components: QueryList<DynamicMaterialFormControlContainerComponent>;

  constructor(
    protected layoutService: DynamicFormLayoutService,
    protected validationService: DynamicFormValidationService
  ) {
    super(layoutService, validationService);
  }
}
